var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar-wrapper"},[_c('base-container',[_c('div',{staticClass:"progress-bar"},_vm._l((_vm.barItems),function(item){return _c('span',{key:item.name,staticClass:"progress-item",class:{active: item.to === _vm.$app.page.route.meta.alias}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }